module.exports = "/images/logo_sdac_bm.png?092c10eb14c9a4f5d435a675d121d6d1";